import type { ChipStatus } from '@elementary/common-ui/components/Chip/StatusChip';
import type { SignalInfo } from './types';

const LAST_STATUS_TO_CHIP: Record<string, ChipStatus> = {
  error: 'error',
  fail: 'fail',
  failure: 'fail',
  pass: 'pass',
  passed: 'passed',
  success: 'success',
  warn: 'warn',
  warning: 'warning',
  no_data: 'noData',
  nodata: 'noData',
  skipped: 'skipped',
  skip: 'skip',
  idle: 'idle',
  runtime_error: 'runtime_error',
};

const FAILURE_CHIP_STATUSES: ReadonlySet<ChipStatus> = new Set([
  'error',
  'fail',
  'runtime_error',
]);

export function lastStatusToChipStatus(lastStatus: string | null): ChipStatus {
  if (!lastStatus) return 'noData';
  const key = lastStatus.toLowerCase().replace(/-/g, '_');
  return LAST_STATUS_TO_CHIP[key] ?? 'noData';
}

export function isFailureChipStatus(lastStatus: string | null): boolean {
  return FAILURE_CHIP_STATUSES.has(lastStatusToChipStatus(lastStatus));
}

type MonitorSignalStatus = Pick<SignalInfo, 'lastStatus' | 'isActive'>;

export function getMonitorChipStatus(signal: MonitorSignalStatus): ChipStatus {
  if (!signal.isActive) return 'resolved';
  return lastStatusToChipStatus(signal.lastStatus);
}
